// Keep the API's country values stable while localizing the registration menu.
export const registrationCountries = [
  { value: 'Greece', label: 'registration_country_greece' },
  { value: 'Cyprus', label: 'registration_country_cyprus' },
];

export const DEFAULT_REGISTRATION_COUNTRY = 'Greece';
export const DEFAULT_REGISTRATION_SPORT = 'football';
export const isRegistrationCountry = (value) => registrationCountries.some((country) => country.value === value);
